(function (c, $, document) {
    $(document).on('click', '.js-reveal-cancel', function(e) {
        e.preventDefault();
        var $modal = $(this).parents('.reveal-modal');
        $modal.foundation('reveal', 'close');
    });

    $(document).on('click', '.js-reveal-confirm', function (e) {
        e.preventDefault();
        var $modal = $(this).parents('.reveal-modal');
        $modal.foundation('reveal', 'close');
        window.location.href = $modal.data('confirm-referrer');
    });

    c.ConfirmWithReveal = function(button, event, modal) {

        if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

        var $referrer = $(button);
        var $modal = $(modal);

        $modal.data('confirm-referrer', $referrer.attr("href"));

        $modal.foundation('reveal', 'open');
    };

})(Crafted.Plugins, jQuery, document);